import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IDefectList, TOperationAndSelectedIssueList } from '@monorepo/types';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { FilterMasterdataListComponent } from '../filter-masterdata-list/filter-masterdata-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-issue-selection',
  templateUrl: './issue-selection.component.html',
  styleUrls: ['./issue-selection.component.scss'],
})
export class IssueSelectionComponent implements OnInit {
  @Input() operationAndSelectedIssueList: TOperationAndSelectedIssueList[] = [];
  @Input() issueList: IDefectList[] = [];
  @Input() allIssueList: IDefectList[] = [];
  @Output() back = new EventEmitter<TOperationAndSelectedIssueList[]>();
  @Output() next = new EventEmitter<TOperationAndSelectedIssueList[]>();
  @Output() cancel = new EventEmitter<'CANCEL'>();
  @Output() clearAll = new EventEmitter<'CLEAR_ALL'>();
  @Output() viewAll = new EventEmitter<string[]>();

  backArrow = '/assets/md-point/header-back-arrow.svg';
  activeIndex: number = 0;

  constructor(
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private modalCtrl: ModalController,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    console.log('[issueList]', this.issueList);
    console.log('[operationAndSelectedIssueList]', this.operationAndSelectedIssueList);
  }

  async onViewAllClick() {
    const modal = await this.modalCtrl.create({
      component: FilterMasterdataListComponent,
      componentProps: {
        type: 'OPERATION_OR_DEFECT',
        lists: this.allIssueList,
        preSelectedLists: this.issueList,
        title: 'issue_selection.listOfIssues',
        showCategoryId: true,
      },
      cssClass: 'm-modal_reject_flow_component',
      backdropDismiss: false,
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (res.data) {
        const t = res.data as IDefectList[];
        this.viewAll.emit(t.map((x) => x.name));
      }
    });
  }

  updateActiveIndex(index: number) {
    this.activeIndex = index;
  }

  handleBack() {
    this.back.emit(this.operationAndSelectedIssueList);
  }

  handleNext() {
    const isNextCondition = !this.operationAndSelectedIssueList.find((item) => item.selectedIssue.length === 0);
    if (isNextCondition) {
      console.log('[FINAL_SELECTED_OPERATION_AND_ISSUE_LIST]', this.operationAndSelectedIssueList);
      this.next.emit(this.operationAndSelectedIssueList);
    } else
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('input_app_common.alert'),
        this.translate.instant('issue_selection.pleaseSelectItems'),
      );
  }

  handleCancel() {
    this.cancel.emit('CANCEL');
  }

  handleClearAll() {
    this.operationAndSelectedIssueList = this.operationAndSelectedIssueList.map((item) => {
      return {
        ...item,
        selectedIssue: [],
      };
    });
    this.clearAll.emit('CLEAR_ALL');
  }

  handleIssueSelection(selectedIssues: any) {
    this.operationAndSelectedIssueList[this.activeIndex].selectedIssue = selectedIssues as IDefectList[];
  }
}
